import { smsCredits } from './smsCredits';
export function SmsCreditEstimate({message,recipients}:{message:string;recipients:number}) {
 const estimate=smsCredits(message);
 return <div className={`sms-credit-estimate${estimate.credits>1?' sms-credit-estimate--multiple':''}`} role="status" aria-live="polite">
  <strong>ใช้ประมาณ {estimate.credits.toLocaleString()} เครดิต/คน · รวม {(estimate.credits*recipients).toLocaleString()} เครดิต</strong>
  <span>{estimate.credits} เครดิต × {recipients.toLocaleString()} เบอร์ที่พร้อมส่ง · {estimate.units.toLocaleString()} หน่วยอักษร ({estimate.encoding==='Unicode'?'ภาษาไทย / Unicode':'อังกฤษ / GSM-7'})</span>
  <small>{estimate.encoding==='Unicode'?'ไทย/Unicode':'อังกฤษ/GSM-7'}: ไม่เกิน {estimate.singleLimit} หน่วย = 1 เครดิต · เมื่อเกิน แบ่งส่วนละ {estimate.multipartLimit} หน่วย · Emoji และอักขระพิเศษบางตัวนับมากกว่า 1 หน่วย</small>
  <small>ประมาณการก่อนส่ง เครดิตที่หักจริงยึดตาม THSMS</small>
 </div>;
}
